import * as go from 'gojs';

import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { getPartsKeys } from 'src/containers/ProjectDiagram/utils/getPartsKeys';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const setModelSelection =
  (selection: go.Set<go.Part>) => (model: Model) => {
    setDataProperty<ModelData>(model)(
      model.modelData,
      'selection',
      getPartsKeys(selection)
    );
  };
